export default {
  tXTEV7yH: "SgVkYp3s5v8y/B?E(H+MbQeThWmZq4t7",
  version: "2020.05.10 @ " + process.env.VUE_APP_TITLE,
  baseUrl: process.env.VUE_APP_BASE_URL,
  r1Url: process.env.VUE_APP_R1_URL,
  r2Url: process.env.VUE_APP_R2_URL,
  r3Url: process.env.VUE_APP_R3_URL,
  resourceImgUrl: process.env.VUE_APP_RESOURCE,

  arcadePath: process.env.VUE_APP_AR_DETAIL_URL,
  arcadeCert: process.env.VUE_APP_AR_DETAIL_CERT,

  pgsPath: process.env.VUE_APP_PGS_DETAIL_URL,
  ppgPath: process.env.VUE_APP_PPG_DETAIL_URL,
  jkrPath: process.env.VUE_APP_JKR_DETAIL_URL,
  sppPath: process.env.VUE_APP_SPP_DETAIL_URL,
  jiliPath: process.env.VUE_APP_JILI_DETAIL_URL,
  lcppgPath: process.env.VUE_APP_LCPPG_DETAIL_URL,
  uuslPath: process.env.VUE_APP_UUSL_DETAIL_URL,
  nextPath: process.env.VUE_APP_NEXT_DETAIL_URL,
  dbhashPath: process.env.VUE_APP_DBHASH_DETAIL_URL,
  wowgamingPath: process.env.VUE_APP_WOWGAMING_DETAIL_URL,
  aicasinoPath: process.env.VUE_APP_AICASINO_DETAIL_URL,
  live22Path: process.env.VUE_APP_LIVE22_DETAIL_URL,
  wfPath: process.env.VUE_APP_WF_DETAIL_URL,
  epwPath: process.env.VUE_APP_EPW_DETAIL_URL,
  awcPath: process.env.VUE_APP_AWC_DETAIL_URL,
  aioPath: process.env.VUE_APP_AIO_DETAIL_URL,

  myanmarLogin: process.env.VUE_APP_MYANMAR_LOGIN == "true",

  userBaseUrl: "/agent",
  accessRoles: {
    account: "account",
    editAccount: "edit_account",
    editLimit: "edit_limit",
    settlement: "settlement",
    report: "report",
    log: "log",
    forecast: "forecast",
    stock: "stock",
    messages: "messages",
    subAccount: "sub_account"
  },
  useConfigUrl: process.env.VUE_APP_STATIC_URL == "true",
  getDomain(url, subdomain) {
    subdomain = subdomain || false;

    url = url.replace(/(https?:\/\/)?(www.)?/i, "");

    if (!subdomain) {
      url = url.split(".");

      url = url.slice(url.length - 2).join(".");
    }

    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }

    return url;
  },
  getBaseUrl() {
    if (this.useConfigUrl) {
      return this.baseUrl;
    }
    var domain = this.getDomain(window.location.hostname, false);
    if (domain != "localhost") {
      return "https://api." + domain;
      // if(["excel888.com","dragon388.com","join288.com","tesla28.com"].includes(domain)) {
      //   return "https://api." + domain;
      // } else {
      //   return "https://myw0066006.com";
      // }
    } else {
      return this.baseUrl;
    }
  },
  r1ResultUrl() {
    // All casino
    return this.r1Url + "/result?";
  },
  r2ResultUrl() {
    // GamingSoft
    return this.r2Url + "/result?bet_id=";
  },
  r3ResultUrl() {
    // Live22
    return this.r3Url + "/result?bet_id=";
  },
  secureloginUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/securelogin";
  },
  // loginUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/login";
  // },
  loginSessionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/login_session";
  },
  addSubAccountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/add_sub";
  },
  addAccountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/add_account";
  },
  addAccountMmoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/add_account_mmo";
  },
  secAccountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/add_secondary";
  },
  secAccountFullUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/add_secondary_full";
  },
  securityDisableUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/security_disable";
  },
  securityUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/security_update";
  },
  securityValidateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/security_validate";
  },
  updatePasswordUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/password_update";
  },
  getPositionTakingUrl() {
    return this.getBaseUrl() + "/settings/position_get";
  },
  getCommissionUrl() {
    return this.getBaseUrl() + "/settings/commission_get";
  },
  getBetLimitUrl() {
    return this.getBaseUrl() + "/settings/bet_limit_get";
  },
  getScheduleUrl() {
    return this.getBaseUrl() + "/settings/schedule_get";
  },
  getWalletUrl() {
    return this.getBaseUrl() + "/settings/wallet_get";
  },
  getPlatformUrl() {
    return this.getBaseUrl() + "/settings/platform_get";
  },
  getPlatformLookUpUrl() {
    return this.getBaseUrl() + "/settings/platform_lookup";
  },
  updatePlatformUrl() {
    return this.getBaseUrl() + "/settings/update_platform";
  },
  resetWinUrl() {
    return this.getBaseUrl() + "/settings/reset_accumulate_win";
  },
  getCreditUsedDownlineUrl() {
    return this.getBaseUrl() + "/settings/credit_used_downline";
  },
  getSubAccountListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account_sub_list";
  },
  getAccountListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account_agent_list";
  },
  getMemberListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account_member_list";
  },
  getMemberListAlertUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account_member_list_alert";
  },
  updateStatusUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/status_update";
  },
  unblockProfileUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account_profile_unblock";
  },
  resetPasswordUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/password_reset";
  },
  resetPasswordPostUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/password_reset_post";
  },
  resetPasswordSubUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/password_reset_sub";
  },
  updateCommissionSBUrl() {
    return this.getBaseUrl() + "/settings/update_commission_sportsbook";
  },
  updateCommissionMMOUrl() {
    return this.getBaseUrl() + "/settings/update_commission_sportsbook_mmo";
  },
  updateCommissionSLUrl() {
    return this.getBaseUrl() + "/settings/update_commission_slots";
  },
  updateCommissionLCUrl() {
    return this.getBaseUrl() + "/settings/update_commission_livecasino";
  },
  updateCommissionLOUrl() {
    return this.getBaseUrl() + "/settings/update_commission_lotto";
  },
  updateCommissionKNUrl() {
    return this.getBaseUrl() + "/settings/update_commission_keno";
  },
  updateCommissionCFUrl() {
    return this.getBaseUrl() + "/settings/update_commission_cockfight";
  },
  updateCommissionLTUrl() {
    return this.getBaseUrl() + "/settings/update_commission_lottery";
  },
  updateCommissionTNUrl() {
    return this.getBaseUrl() + "/settings/update_commission_tournament";
  },
  updateBetLimitSBUrl() {
    return this.getBaseUrl() + "/settings/update_bet_limit_sportsbook";
  },
  updateBetLimitLCUrl() {
    return this.getBaseUrl() + "/settings/update_bet_limit_livecasino";
  },
  updateBetLimitLOUrl() {
    return this.getBaseUrl() + "/settings/update_bet_limit_lotto";
  },
  updateBetLimitKNUrl() {
    return this.getBaseUrl() + "/settings/update_bet_limit_keno";
  },
  updateBetLimitCFUrl() {
    return this.getBaseUrl() + "/settings/update_bet_limit_cockfight";
  },
  updateBetLimitLTUrl() {
    return this.getBaseUrl() + "/settings/update_bet_limit_lottery";
  },
  updatePositionTakingSB1Url() {
    return this.getBaseUrl() + "/settings/update_position_sportsbook";
  },
  updatePositionTakingSB2Url() {
    return this.getBaseUrl() + "/settings/update_position_sportsbook_2";
  },
  updatePositionTakingMMOUrl() {
    return this.getBaseUrl() + "/settings/update_position_sportsbook_mmo";
  },
  updatePositionTakingSLUrl() {
    return this.getBaseUrl() + "/settings/update_position_slots";
  },
  updatePositionTakingLCUrl() {
    return this.getBaseUrl() + "/settings/update_position_livecasino";
  },
  updatePositionTakingLOUrl() {
    return this.getBaseUrl() + "/settings/update_position_lotto";
  },
  updatePositionTakingKNUrl() {
    return this.getBaseUrl() + "/settings/update_position_keno";
  },
  updatePositionTakingCFUrl() {
    return this.getBaseUrl() + "/settings/update_position_cockfight";
  },
  updatePositionTakingLTUrl() {
    return this.getBaseUrl() + "/settings/update_position_lottery";
  },
  checkDirectDownlineUrl() {
    return this.getBaseUrl() + "/settings/account_check_direct_downline";
  },
  getOverviewSummaryUrl() {
    return this.getBaseUrl() + "/settings/account_status_summary";
  },
  getAccountWinloseUrl() {
    return this.getBaseUrl() + "/settings/account_winlose";
  },
  getAccountOutstandingUrl() {
    return this.getBaseUrl() + "/settings/account_outstanding";
  },
  getActiveAccountUrl() {
    return this.getBaseUrl() + "/settings/active_account";
  },
  getTop10AccountUrl() {
    return this.getBaseUrl() + "/settings/account_top_10";
  },
  updateAccountDetailsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/update_account";
  },
  getAccountDetailsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account_detail";
  },
  getSubAccountDetailsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account_sub_detail";
  },
  updateAuthorityUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/set_authority";
  },
  subAccountBlockUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account_sub_block";
  },
  subAccountUnblockUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/account_sub_unblock";
  },
  accessLogUrl() {
    return this.getBaseUrl() + "/logs/access_log";
  },
  getMemberLogUrl() {
    return this.getBaseUrl() + "/logs/member_log";
  },
  accountLogUrl() {
    return this.getBaseUrl() + "/logs/account_log";
  },
  positionTakingLogUrl() {
    return this.getBaseUrl() + "/logs/position_taking_log";
  },
  betLimitLogUrl() {
    return this.getBaseUrl() + "/logs/bet_limit_log";
  },
  commissionLogUrl() {
    return this.getBaseUrl() + "/logs/commission_log";
  },
  transactionLogUrl() {
    return this.getBaseUrl() + "/logs/transaction_log";
  },
  getMatchLookupUrl() {
    return this.getBaseUrl() + "/forecast/match_lookup";
  },
  getForecastLookupUrl() {
    return this.getBaseUrl() + "/forecast/forecast_lookup";
  },
  getForecastListUrl() {
    return this.getBaseUrl() + "/forecast/forecast_list";
  },
  getSettlementAgentListUrl() {
    return this.getBaseUrl() + "/settlement/settlement_agent_list";
  },
  getSettlementMemberListUrl() {
    return this.getBaseUrl() + "/settlement/settlement_member_list";
  },
  getSettlementMemberListCashUrl() {
    return this.getBaseUrl() + "/settlement/settlement_member_list_cash";
  },
  settlementAgentUrl() {
    return this.getBaseUrl() + "/settlement/settlement_agent";
  },
  settlementMemberUrl() {
    return this.getBaseUrl() + "/settlement/settlement_member";
  },
  settlementMemberCashUrl() {
    return this.getBaseUrl() + "/settlement/settlement_member_cash";
  },
  settlementAgentBulkUrl() {
    return this.getBaseUrl() + "/settlement/settlement_agent_bulk";
  },
  settlementMemberBulkUrl() {
    return this.getBaseUrl() + "/settlement/settlement_member_bulk";
  },
  settlementMemberBulkCashUrl() {
    return this.getBaseUrl() + "/settlement/settlement_member_cash_bulk";
  },
  transferCashMemberUrl() {
    return this.getBaseUrl() + "/settlement/transfer_cash_member_mmo";
  },
  transferCashAgentUrl() {
    return this.getBaseUrl() + "/settlement/transfer_cash_mmo";
  },
  getSettlementHistoryUrl() {
    return this.getBaseUrl() + "/report/settlement_history";
  },
  getDailyStatementUrl() {
    return this.getBaseUrl() + "/report/daily_statement";
  },
  getDailySettlementUrl() {
    return this.getBaseUrl() + "/report/daily_settlement";
  },
  getDailyWinloseUrl() {
    return this.getBaseUrl() + "/report/daily_winlose";
  },
  getDailyWinloseDetailUrl() {
    return this.getBaseUrl() + "/report/daily_winlose_detail";
  },
  getPlatformWinloseUrl() {
    return this.getBaseUrl() + "/report/platform_winlose";
  },
  getPlatformWinloseDetailUrl() {
    return this.getBaseUrl() + "/report/platform_winlose_detail";
  },
  getSportTypeWinloseUrl() {
    return this.getBaseUrl() + "/report/sport_type_winlose";
  },
  getSportTypeWinloseDetailUrl() {
    return this.getBaseUrl() + "/report/sport_type_winlose_detail";
  },
  getLeagueWinloseUrl() {
    return this.getBaseUrl() + "/report/league_winlose";
  },
  getLeagueWinloseDetailUrl() {
    return this.getBaseUrl() + "/report/league_winlose_detail";
  },
  getMatchWinloseUrl() {
    return this.getBaseUrl() + "/report/match_winlose";
  },
  getMatchWinloseDetailUrl() {
    return this.getBaseUrl() + "/report/match_winlose_detail";
  },
  getMatchMemberWinloseUrl() {
    return this.getBaseUrl() + "/report/match_member_winlose";
  },
  getMatchMemberWinloseDetailUrl() {
    return this.getBaseUrl() + "/report/match_member_winlose_detail";
  },
  getSystemParlayUrl() {
    return this.getBaseUrl() + "/report/system_parlay";
  },
  getBetSystemParlayUrl() {
    return this.getBaseUrl() + "/report/system_parlay_mb";
  },
  getBetSystemParlayMatchUrl() {
    return this.getBaseUrl() + "/report/system_parlay_mb_match";
  },
  getBetSystemParlayBetUrl() {
    return this.getBaseUrl() + "/report/system_parlay_mb_bet";
  },
  getCancelledBetlistUrl() {
    return this.getBaseUrl() + "/report/cancelled_bet_list";
  },
  getTournamentRefundListUrl() {
    return this.getBaseUrl() + "/report/game_result_tournament_refund";
  },
  getStockHDPUrl() {
    return this.getBaseUrl() + "/report/stock_hdp";
  },
  getStockOEUrl() {
    return this.getBaseUrl() + "/report/stock_oe";
  },
  getStockOutstandingUrl() {
    return this.getBaseUrl() + "/report/stock_outstanding";
  },
  getStockOutstandingLotteryUrl() {
    return this.getBaseUrl() + "/report/stock_outstanding_lottery";
  },
  getActiveBetlistHDPUrl() {
    return this.getBaseUrl() + "/report/active_bet_list_hdp";
  },
  getActiveBetlistOEUrl() {
    return this.getBaseUrl() + "/report/active_bet_list_oe";
  },
  getActiveBetlistBetTypeUrl() {
    return this.getBaseUrl() + "/report/active_bet_list_bet_type";
  },
  getActiveBetlistAllUrl() {
    return this.getBaseUrl() + "/report/active_bet_list_all";
  },
  getActiveBetlistDetailUrl() {
    return this.getBaseUrl() + "/report/active_bet_list_detail";
  },
  getActiveBetlistMatchUrl() {
    return this.getBaseUrl() + "/report/active_bet_list_match";
  },
  getActiveBetlistLotteryUrl() {
    return this.getBaseUrl() + "/report/active_bet_list_lottery";
  },
  getActiveBetlistESports2Url() {
    return this.getBaseUrl() + "/report/active_bet_list_esports";
  },
  getPendingMatchesUrl() {
    return this.getBaseUrl() + "/report/pending_matches";
  },
  getGameResultSportsbookUrl() {
    return this.getBaseUrl() + "/report/game_result_sportsbook";
  },
  getGameResultSportsbookDetailUrl() {
    return this.getBaseUrl() + "/report/game_result_sportsbook_detail";
  },
  getGameResultSlotsUrl() {
    return this.getBaseUrl() + "/report/game_result_slots";
  },
  getGameResultSlotsDetailUrl() {
    return this.getBaseUrl() + "/report/game_result_slots_detail";
  },
  getGameResultLivecasinoUrl() {
    return this.getBaseUrl() + "/report/game_result_livecasino";
  },
  getGameResultLivecasinoDetailUrl() {
    return this.getBaseUrl() + "/report/game_result_livecasino_detail";
  },
  getGameResultLotteryDetailUrl() {
    return this.getBaseUrl() + "/report/game_result_lottery_detail";
  },
  getParlayDetailUrl() {
    return this.getBaseUrl() + "/report/parlay_detail";
  },
  getParlayDetailMMOUrl() {
    return this.getBaseUrl() + "/report/parlay_detail_mmo";
  },
  getGameResultEsportsDetailUrl() {
    return this.getBaseUrl() + "/report/game_result_esports_detail";
  },
  getGameResultEsportsDetailComboUrl() {
    return this.getBaseUrl() + "/report/game_result_esports_detail_combo";
  },
  getBetListEsportsDetailComboUrl() {
    return this.getBaseUrl() + "/report/bet_esports_combo";
  },
  getGameResultTournamentDetailUrl() {
    return this.getBaseUrl() + "/report/game_result_tournament_detail";
  },
  getGameResultAdjustmentDetailUrl() {
    return this.getBaseUrl() + "/report/game_result_sportsbook_refund_detail";
  },
  getGameTypeLookupUrl() {
    return this.getBaseUrl() + "/report/match_result_gametype_lookup";
  },
  getLeagueLookupUrl() {
    return this.getBaseUrl() + "/report/match_result_league_lookup";
  },
  getMatchResultUrl() {
    return this.getBaseUrl() + "/report/match_result";
  },
  announceListUrl() {
    return this.getBaseUrl() + "/announcement/announce_member_list";
  },
  marqueeListUrl() {
    return this.getBaseUrl() + "/announcement/announce_member_marquee";
  },
  personalListUrl() {
    return this.getBaseUrl() + "/announcement/announce_member_personal";
  },
  personalUnreadUrl() {
    return this.getBaseUrl() + "/announcement/announce_member_personal_unread";
  },
  checkDownlineUrl() {
    return this.getBaseUrl() + "/settings/account_check";
  },
  checkDownlineExistUrl() {
    return this.getBaseUrl() + "/settings/account_check_exists";
  },
  checkAccountReservedUrl() {
    return this.getBaseUrl() + "/settings/account_check_reserved";
  },
  getCreditUsedSummaryUrl() {
    return this.getBaseUrl() + "/settings/credit_used_summary";
  },
  getTournamentJackpotUrl() {
    return this.getBaseUrl() + "/report/tournament_jackpot";
  },
};
